import Log from '../lib/log';
import { v2api } from '../api/axios';
import { setupUserType } from '../store/setupUserSlice';

// ログの初期化
const log = new Log('UpgradeUser');

// 入力値のチェック
const checkStoreData = (storeData: setupUserType) => {
  console.log(`🐞 storeData: ${JSON.stringify(storeData, null, '\t')}`);
  let confirm = true;
  if (
    !storeData.id ||
    !storeData.nickname ||
    !storeData.email ||
    !storeData.stripeCardTokenId ||
    !storeData.responseText ||
    !storeData.userNumber ||
    !storeData.token
  )
    confirm = false;
  return confirm;
};

// 050番号の取得
const getServiceNumber = async (storeData: setupUserType) => {
  console.log(`🐞 getServiceNumber start.`);
  let serviceNumber = '';

  try {
    const postData = {
      userId: storeData.id,
      token: storeData.token,
    };
    const res = await v2api.post('/update-service-number', postData);
    if (res.data.statusCode !== 200) {
      throw new Error(`update-service-number error: ${res.data.statusCode}`);
    }
    serviceNumber = JSON.parse(res.data.body).service_number;
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
  }

  return serviceNumber;
};

// 応答メッセージの生成
const createResponseMessage = async (storeData: setupUserType) => {
  console.log(`🐞 createResponseMessage start.`);
  let completed = true;

  try {
    const postData = {
      userId: storeData.id,
      token: storeData.token,
      text: storeData.responseText,
      voiceType: storeData.responseVoiceType.toString(),
    };
    const res = await v2api.post('/change-response', postData);
    if (res.data.statusCode !== 200) {
      completed = false;
      throw new Error(`change-response error: ${res.data.statusCode}`);
    }
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
    completed = false;
  }

  return completed;
};

// Stripeデータの生成
const createStripeCustomer = async (storeData: setupUserType) => {
  console.log(`🐞 createStripeCustomer start.`);
  let completed = true;

  try {
    const postData = {
      userId: storeData.id,
      token: storeData.token,
      tokenId: storeData.stripeCardTokenId,
    };
    const res = await v2api.post('/create-stripe-customer', postData);
    if (res.data.statusCode !== 200) {
      completed = false;
      throw new Error(`create-stripe-customer error: ${res.data.statusCode}`);
    }
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
    completed = false;
  }

  return completed;
};

// ユーザーデータの作成
const updateUser = async (storeData: setupUserType) => {
  console.log(`🐞 updateUser start.`);
  let completed = true;

  // apiキーとapi_secretの生成
  const S = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const apiKey = `PK${Math.floor(Math.random() * 100000000)
    .toString()
    .padStart(8, '0')}`;
  const apiSecret = Array.from(Array(64))
    .map(() => S[Math.floor(Math.random() * S.length)])
    .join('');

  try {
    // ユーザー情報を更新する
    let query = `
      mutation UpdateDB(
        $id: String!, 
        $add_message: Int, 
        $api_key: String!, 
        $api_secret: String!,
        $free_bonus: Int, 
        $inviter: String, 
        $user_name: String, 
        $user_status: Int, 
        $address: String!, 
        $attach_media: Int!, 
        $in_message: Int!,
        $response_change_count: Int, 
        $incoming_notice: Int!
      ) {
        updateUsers(
          input: {
            id: $id, 
            add_message: $add_message, 
            api_keys: {
              api_key: $api_key, 
              api_secret: $api_secret
            }, 
            inviter: $inviter, 
            free_bonus: $free_bonus,
            user_name: $user_name, 
            user_status: $user_status, 
            recipients: {
              address: $address, 
              attach_media: $attach_media, 
              in_message: $in_message, 
              incoming_notice: $incoming_notice
            },
            response_change_count: $response_change_count
          }
        ) {
          id
        }
      }
    `;
    const postData = {
      userId: storeData.id,
      token: storeData.token,
      query,
      variables: {
        id: storeData.id,
        add_message: storeData.addMessage,
        api_key: apiKey,
        api_secret: apiSecret,
        inviter: storeData.inviter,
        free_bonus: storeData.inviter ? 1 : 0,
        user_name: storeData.nickname,
        user_status: 1,
        address: storeData.email,
        attach_media: storeData.attachMedia,
        in_message: storeData.inMessage,
        incoming_notice: storeData.incomingNotice,
        response_change_count: 0,
      },
    };
    const res = await v2api.post('/update-db', postData);
    if (res.data.statusCode !== 200) {
      completed = false;
      throw new Error(`update-db error: ${res.data.statusCode}`);
    }
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
    completed = false;
  }

  return completed;
};

// 招待者のフリーボーナスを加算
const addBonus = async (storeData: setupUserType) => {
  console.log(`🐞 addBonus start.`);
  let completed = true;
  let inviterUser = null;
  try {
    // ユーザー情報を取得する
    const response = await v2api.post('/get-user', {
      userId: storeData.inviter,
      token: storeData.inviterToken,
    });
    if (response.data.statusCode === 200) {
      // 取得成功
      inviterUser = JSON.parse(response.data.body);
    } else {
      completed = false;
      throw new Error(`getUser error: ${response.data.statusCode}`);
    }
    // 招待者を更新する
    let query = `
      mutation UpdateDB(
        $id: String!, 
        $free_bonus: Int
      ) {
        updateUsers(
          input: {
            id: $id, 
            free_bonus: $free_bonus
          }
        ) {
          id
        }
      }
    `;
    const postData = {
      userId: storeData.inviter,
      token: storeData.inviterToken,
      query,
      variables: {
        id: storeData.inviter,
        free_bonus: inviterUser.free_bonus + 1,
      },
    };
    const res = await v2api.post('/update-db', postData);
    if (res.data.statusCode !== 200) {
      completed = false;
      throw new Error(`update-db error: ${res.data.statusCode}`);
    }
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
    completed = false;
  }

  return completed;
};

export default function upgradeUser(setupUser: setupUserType): Promise<string> {
  log.putLog('info', 'UpgradeUser started.');

  return new Promise((resolve, reject) => {
    (async () => {
      // 入力値のチェック
      if (!checkStoreData(setupUser)) {
        log.putLog('error', 'Invalid Setup data.');
        reject('Invalid Setup data.');
      }

      // 応答メッセージの作成
      if (!(await createResponseMessage(setupUser))) {
        log.putLog('error', 'Create response message failed.');
        reject('Create response message failed.');
      }

      // Stripeの作成
      if (!(await createStripeCustomer(setupUser))) {
        log.putLog('error', 'Create stripe customer failed.');
        reject('Create stripe customer failed.');
      }

      // Twilio番号の購入
      const serviceNumber = await getServiceNumber(setupUser);
      if (serviceNumber === '') {
        log.putLog('error', 'Get number failed.');
        reject('Get number failed.');
      }

      // userの更新
      if (!(await updateUser(setupUser))) {
        log.putLog('error', 'Update user failed.');
        reject('Update user failed.');
      }

      // 招待者のボーナスを加算
      if (setupUser.inviter) {
        if (!(await addBonus(setupUser))) {
          log.putLog('error', 'Add free bonus failed.');
          reject('Add free bonus failed.');
        }
      }

      resolve(serviceNumber);
    })();
  });
}
